// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2CTGp","header":"ClearentDisclaimer_header__3l-my","inner":"ClearentDisclaimer_inner__2Td1F"};